<template>
  <div></div>
</template>

<script>
export default {
  name: "tool-edit-info-link",
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>